import { HardHat } from '@phosphor-icons/react';
import './EmptyPage.css';

function EmptyPage({ title, icon: Icon, description }) {
  return (
    <div className="empty-page">
      <div className="empty-page-content">
        <div className="empty-icon">
          {Icon ? <Icon size={64} weight="duotone" /> : <HardHat size={64} weight="duotone" />}
        </div>
        <h1>{title}</h1>
        <p>{description || 'עמוד זה נמצא בבנייה ויהיה זמין בקרוב.'}</p>
        <div className="coming-soon-badge">
          <HardHat size={18} weight="fill" />
          <span>בקרוב</span>
        </div>
      </div>
    </div>
  );
}

export default EmptyPage;
